// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see StockBuyStartEvent
 *
 * @deprecated Use StockTrade events instead.
 */
export var StockBuyStart = function () { return ({
    name: "Stock Buy Start",
    parameters: {
        cdf_entity: "Stock",
        cdf_action: "Buy",
    }
}); };
/**
 * @see StockBuyEnterAmountEvent
 *
 * @deprecated Use StockTrade events instead.
 */
export var StockBuyEnterAmount = function () { return ({
    name: "Stock Buy EnterAmount",
    parameters: {
        cdf_entity: "Stock",
        cdf_action: "Buy",
    }
}); };
/**
 * @see StockBuySelectPriceRangeEvent
 *
 * @deprecated Use StockTrade events instead.
 */
export var StockBuySelectPriceRange = function (_a) {
    var orderSide = _a.orderSide, range = _a.range, orderAssetType = _a.orderAssetType;
    return ({
        name: "Stock Buy SelectPriceRange",
        parameters: {
            cdf_entity: "Stock",
            cdf_action: "Buy",
            order_side: orderSide !== undefined && orderSide !== null ? orderSide.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            range: range !== undefined && range !== null ? range.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            order_asset_type: orderAssetType !== undefined && orderAssetType !== null ? orderAssetType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see StockBuySelectPriceEvent
 *
 * @deprecated Use StockTrade events instead.
 */
export var StockBuySelectPrice = function (_a) {
    var orderSide = _a.orderSide, orderAssetType = _a.orderAssetType;
    return ({
        name: "Stock Buy SelectPrice",
        parameters: {
            cdf_entity: "Stock",
            cdf_action: "Buy",
            order_side: orderSide !== undefined && orderSide !== null ? orderSide.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            order_asset_type: orderAssetType !== undefined && orderAssetType !== null ? orderAssetType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see StockSellStartEvent
 *
 * @deprecated Use StockTrade events instead.
 */
export var StockSellStart = function () { return ({
    name: "Stock Sell Start",
    parameters: {
        cdf_entity: "Stock",
        cdf_action: "Sell",
    }
}); };
/**
 * @see StockSellEnterAmountEvent
 *
 * @deprecated Use StockTrade events instead.
 */
export var StockSellEnterAmount = function () { return ({
    name: "Stock Sell EnterAmount",
    parameters: {
        cdf_entity: "Stock",
        cdf_action: "Sell",
    }
}); };
/**
 * @see StockSendCloseEvent
 */
export var StockSendClose = function () { return ({
    name: "Stock Send Close",
    parameters: {
        cdf_entity: "Stock",
        cdf_action: "Send",
    }
}); };
/**
 * @see StockSendStartEvent
 */
export var StockSendStart = function () { return ({
    name: "Stock Send Start",
    parameters: {
        cdf_entity: "Stock",
        cdf_action: "Send",
    }
}); };
/**
 * @see StockSendSelectStockNameEvent
 */
export var StockSendSelectStockName = function (_a) {
    var origin = _a.origin;
    return ({
        name: "Stock Send SelectStockName",
        parameters: {
            cdf_entity: "Stock",
            cdf_action: "Send",
            origin: origin !== undefined && origin !== null ? origin.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see StockTradeStartEvent
 */
export var StockTradeStart = function (_a) {
    var orderSide = _a.orderSide, ticker = _a.ticker, equityType = _a.equityType;
    return ({
        name: "Stock Trade Start",
        parameters: {
            cdf_entity: "Stock",
            cdf_action: "Trade",
            order_side: orderSide !== undefined && orderSide !== null ? orderSide.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            ticker: ticker !== undefined && ticker !== null ? ticker.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            equity_type: equityType !== undefined && equityType !== null ? equityType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see StockTradeStartSellSucceededEvent
 */
export var StockTradeStartSellSucceeded = function () { return ({
    name: "Stock Trade StartSellSucceeded",
    parameters: {
        cdf_entity: "Stock",
        cdf_action: "Trade",
    }
}); };
/**
 * @see StockTradeStartSellFailedEvent
 */
export var StockTradeStartSellFailed = function () { return ({
    name: "Stock Trade StartSellFailed",
    parameters: {
        cdf_entity: "Stock",
        cdf_action: "Trade",
    }
}); };
/**
 * @see StockTradeEnterAmountEvent
 */
export var StockTradeEnterAmount = function (_a) {
    var orderSide = _a.orderSide, ticker = _a.ticker, amount = _a.amount, amountText = _a.amountText;
    return ({
        name: "Stock Trade EnterAmount",
        parameters: {
            cdf_entity: "Stock",
            cdf_action: "Trade",
            order_side: orderSide !== undefined && orderSide !== null ? orderSide.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            ticker: ticker !== undefined && ticker !== null ? ticker.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            amount: amount !== undefined && amount !== null ? amount.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            amount_text: amountText !== undefined && amountText !== null ? amountText.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see StockTradeSelectCustomAmountEvent
 */
export var StockTradeSelectCustomAmount = function (_a) {
    var orderSide = _a.orderSide, ticker = _a.ticker;
    return ({
        name: "Stock Trade SelectCustomAmount",
        parameters: {
            cdf_entity: "Stock",
            cdf_action: "Trade",
            order_side: orderSide !== undefined && orderSide !== null ? orderSide.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            ticker: ticker !== undefined && ticker !== null ? ticker.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see StockTradeChangeOrderTypeEvent
 */
export var StockTradeChangeOrderType = function (_a) {
    var orderSide = _a.orderSide, ticker = _a.ticker;
    return ({
        name: "Stock Trade ChangeOrderType",
        parameters: {
            cdf_entity: "Stock",
            cdf_action: "Trade",
            order_side: orderSide !== undefined && orderSide !== null ? orderSide.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            ticker: ticker !== undefined && ticker !== null ? ticker.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see StockTradeSelectCustomOrderEvent
 */
export var StockTradeSelectCustomOrder = function (_a) {
    var orderSide = _a.orderSide, ticker = _a.ticker;
    return ({
        name: "Stock Trade SelectCustomOrder",
        parameters: {
            cdf_entity: "Stock",
            cdf_action: "Trade",
            order_side: orderSide !== undefined && orderSide !== null ? orderSide.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            ticker: ticker !== undefined && ticker !== null ? ticker.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see StockTradeSetCustomOrderEvent
 */
export var StockTradeSetCustomOrder = function (_a) {
    var orderSide = _a.orderSide, ticker = _a.ticker, amount = _a.amount, currentPricePerUnitBps = _a.currentPricePerUnitBps, orderPricePerUnitBps = _a.orderPricePerUnitBps;
    return ({
        name: "Stock Trade SetCustomOrder",
        parameters: {
            cdf_entity: "Stock",
            cdf_action: "Trade",
            order_side: orderSide !== undefined && orderSide !== null ? orderSide.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            ticker: ticker !== undefined && ticker !== null ? ticker.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            amount: amount !== undefined && amount !== null ? amount.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            current_price_per_unit_bps: currentPricePerUnitBps !== undefined && currentPricePerUnitBps !== null ? currentPricePerUnitBps.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            order_price_per_unit_bps: orderPricePerUnitBps !== undefined && orderPricePerUnitBps !== null ? orderPricePerUnitBps.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see StockTradeSelectExpirationEvent
 */
export var StockTradeSelectExpiration = function (_a) {
    var orderSide = _a.orderSide, ticker = _a.ticker, expirationPeriod = _a.expirationPeriod;
    return ({
        name: "Stock Trade SelectExpiration",
        parameters: {
            cdf_entity: "Stock",
            cdf_action: "Trade",
            order_side: orderSide !== undefined && orderSide !== null ? orderSide.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            ticker: ticker !== undefined && ticker !== null ? ticker.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            expiration_period: expirationPeriod !== undefined && expirationPeriod !== null ? expirationPeriod.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see StockTradeSetExpirationEvent
 */
export var StockTradeSetExpiration = function (_a) {
    var orderSide = _a.orderSide, ticker = _a.ticker, expirationPeriod = _a.expirationPeriod;
    return ({
        name: "Stock Trade SetExpiration",
        parameters: {
            cdf_entity: "Stock",
            cdf_action: "Trade",
            order_side: orderSide !== undefined && orderSide !== null ? orderSide.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            ticker: ticker !== undefined && ticker !== null ? ticker.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            expiration_period: expirationPeriod !== undefined && expirationPeriod !== null ? expirationPeriod.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see StockTradeSetPriceEvent
 */
export var StockTradeSetPrice = function (_a) {
    var orderSide = _a.orderSide, ticker = _a.ticker, orderPricePerUnitBps = _a.orderPricePerUnitBps;
    return ({
        name: "Stock Trade SetPrice",
        parameters: {
            cdf_entity: "Stock",
            cdf_action: "Trade",
            order_side: orderSide !== undefined && orderSide !== null ? orderSide.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            ticker: ticker !== undefined && ticker !== null ? ticker.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            order_price_per_unit_bps: orderPricePerUnitBps !== undefined && orderPricePerUnitBps !== null ? orderPricePerUnitBps.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see StockTradeSelectAutoInvestEvent
 */
export var StockTradeSelectAutoInvest = function (_a) {
    var orderSide = _a.orderSide, ticker = _a.ticker;
    return ({
        name: "Stock Trade SelectAutoInvest",
        parameters: {
            cdf_entity: "Stock",
            cdf_action: "Trade",
            order_side: orderSide !== undefined && orderSide !== null ? orderSide.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            ticker: ticker !== undefined && ticker !== null ? ticker.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see StockTradeSetAutoInvestEvent
 */
export var StockTradeSetAutoInvest = function (_a) {
    var orderSide = _a.orderSide, ticker = _a.ticker, frequency = _a.frequency;
    return ({
        name: "Stock Trade SetAutoInvest",
        parameters: {
            cdf_entity: "Stock",
            cdf_action: "Trade",
            order_side: orderSide !== undefined && orderSide !== null ? orderSide.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            ticker: ticker !== undefined && ticker !== null ? ticker.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            frequency: frequency !== undefined && frequency !== null ? frequency.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see StockTradeSubmitAmountEvent
 */
export var StockTradeSubmitAmount = function (_a) {
    var orderSide = _a.orderSide, ticker = _a.ticker, amount = _a.amount, orderType = _a.orderType, frequency = _a.frequency, referrerFlowToken = _a.referrerFlowToken;
    return ({
        name: "Stock Trade SubmitAmount",
        parameters: {
            cdf_entity: "Stock",
            cdf_action: "Trade",
            order_side: orderSide !== undefined && orderSide !== null ? orderSide.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            ticker: ticker !== undefined && ticker !== null ? ticker.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            amount: amount !== undefined && amount !== null ? amount.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            order_type: orderType !== undefined && orderType !== null ? orderType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            frequency: frequency !== undefined && frequency !== null ? frequency.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            referrer_flow_token: referrerFlowToken !== undefined && referrerFlowToken !== null ? referrerFlowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see StockTradeCancelOrderEvent
 */
export var StockTradeCancelOrder = function (_a) {
    var flowToken = _a.flowToken, orderToken = _a.orderToken, ticker = _a.ticker, cancelled = _a.cancelled;
    return ({
        name: "Stock Trade CancelOrder",
        parameters: {
            cdf_entity: "Stock",
            cdf_action: "Trade",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            order_token: orderToken !== undefined && orderToken !== null ? orderToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            ticker: ticker !== undefined && ticker !== null ? ticker.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            cancelled: cancelled !== undefined && cancelled !== null ? cancelled.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see StockTradeCancelOrderResultEvent
 */
export var StockTradeCancelOrderResult = function (_a) {
    var flowToken = _a.flowToken, orderToken = _a.orderToken, ticker = _a.ticker, succeeded = _a.succeeded;
    return ({
        name: "Stock Trade CancelOrderResult",
        parameters: {
            cdf_entity: "Stock",
            cdf_action: "Trade",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            order_token: orderToken !== undefined && orderToken !== null ? orderToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            ticker: ticker !== undefined && ticker !== null ? ticker.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            succeeded: succeeded !== undefined && succeeded !== null ? succeeded.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see StockTradeExitEvent
 */
export var StockTradeExit = function (_a) {
    var orderSide = _a.orderSide, ticker = _a.ticker, equityType = _a.equityType;
    return ({
        name: "Stock Trade Exit",
        parameters: {
            cdf_entity: "Stock",
            cdf_action: "Trade",
            order_side: orderSide !== undefined && orderSide !== null ? orderSide.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            ticker: ticker !== undefined && ticker !== null ? ticker.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            equity_type: equityType !== undefined && equityType !== null ? equityType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see StockViewLearnInvestingEvent
 */
export var StockViewLearnInvesting = function () { return ({
    name: "Stock View LearnInvesting",
    parameters: {
        cdf_entity: "Stock",
        cdf_action: "View",
    }
}); };
/**
 * @see StockViewBrowseNewsEvent
 */
export var StockViewBrowseNews = function (_a) {
    var investmentState = _a.investmentState, newsType = _a.newsType;
    return ({
        name: "Stock View BrowseNews",
        parameters: {
            cdf_entity: "Stock",
            cdf_action: "View",
            investment_state: investmentState !== undefined && investmentState !== null ? investmentState.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            news_type: newsType !== undefined && newsType !== null ? newsType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see StockViewOpenNewsEvent
 */
export var StockViewOpenNews = function (_a) {
    var location = _a.location, newsType = _a.newsType, positionInList = _a.positionInList, source = _a.source;
    return ({
        name: "Stock View OpenNews",
        parameters: {
            cdf_entity: "Stock",
            cdf_action: "View",
            location: location !== undefined && location !== null ? location.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            news_type: newsType !== undefined && newsType !== null ? newsType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            position_in_list: positionInList !== undefined && positionInList !== null ? positionInList.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            source: source !== undefined && source !== null ? source.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see StockViewSortListEvent
 */
export var StockViewSortList = function (_a) {
    var newsType = _a.newsType, sortedBy = _a.sortedBy;
    return ({
        name: "Stock View SortList",
        parameters: {
            cdf_entity: "Stock",
            cdf_action: "View",
            news_type: newsType !== undefined && newsType !== null ? newsType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            sorted_by: sortedBy !== undefined && sortedBy !== null ? sortedBy.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see StockViewBrowseCategoriesEvent
 */
export var StockViewBrowseCategories = function () { return ({
    name: "Stock View BrowseCategories",
    parameters: {
        cdf_entity: "Stock",
        cdf_action: "View",
    }
}); };
/**
 * @see StockViewPresentStockSelectorEvent
 */
export var StockViewPresentStockSelector = function () { return ({
    name: "Stock View PresentStockSelector",
    parameters: {
        cdf_entity: "Stock",
        cdf_action: "View",
    }
}); };
/**
 * @see StockViewOpenStockSearchEvent
 */
export var StockViewOpenStockSearch = function (_a) {
    var source = _a.source;
    return ({
        name: "Stock View OpenStockSearch",
        parameters: {
            cdf_entity: "Stock",
            cdf_action: "View",
            source: source !== undefined && source !== null ? source.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see StockViewViewCategoryEvent
 */
export var StockViewViewCategory = function (_a) {
    var categoryName = _a.categoryName;
    return ({
        name: "Stock View ViewCategory",
        parameters: {
            cdf_entity: "Stock",
            cdf_action: "View",
            category_name: categoryName !== undefined && categoryName !== null ? categoryName.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see StockViewViewStockDetailsEvent
 */
export var StockViewViewStockDetails = function (_a) {
    var ticker = _a.ticker, origin = _a.origin, numSharesOwned = _a.numSharesOwned, valueSharesOwnedBps = _a.valueSharesOwnedBps, autoInvestSetting = _a.autoInvestSetting, firstButtonLabel = _a.firstButtonLabel, secondButtonLabel = _a.secondButtonLabel, thirdButtonLabel = _a.thirdButtonLabel, equityType = _a.equityType;
    return ({
        name: "Stock View ViewStockDetails",
        parameters: {
            cdf_entity: "Stock",
            cdf_action: "View",
            ticker: ticker !== undefined && ticker !== null ? ticker.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            origin: origin !== undefined && origin !== null ? origin.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            num_shares_owned: numSharesOwned !== undefined && numSharesOwned !== null ? numSharesOwned.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            value_shares_owned_bps: valueSharesOwnedBps !== undefined && valueSharesOwnedBps !== null ? valueSharesOwnedBps.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            auto_invest_setting: autoInvestSetting !== undefined && autoInvestSetting !== null ? autoInvestSetting.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            first_button_label: firstButtonLabel !== undefined && firstButtonLabel !== null ? firstButtonLabel.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            second_button_label: secondButtonLabel !== undefined && secondButtonLabel !== null ? secondButtonLabel.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            third_button_label: thirdButtonLabel !== undefined && thirdButtonLabel !== null ? thirdButtonLabel.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            equity_type: equityType !== undefined && equityType !== null ? equityType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see StockViewViewNewsEvent
 */
export var StockViewViewNews = function (_a) {
    var source = _a.source, equityType = _a.equityType;
    return ({
        name: "Stock View ViewNews",
        parameters: {
            cdf_entity: "Stock",
            cdf_action: "View",
            source: source !== undefined && source !== null ? source.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            equity_type: equityType !== undefined && equityType !== null ? equityType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see StockViewViewPortfolioEvent
 */
export var StockViewViewPortfolio = function () { return ({
    name: "Stock View ViewPortfolio",
    parameters: {
        cdf_entity: "Stock",
        cdf_action: "View",
    }
}); };
/**
 * @see StockViewPresentSortByEvent
 */
export var StockViewPresentSortBy = function (_a) {
    var sort = _a.sort, source = _a.source;
    return ({
        name: "Stock View PresentSortBy",
        parameters: {
            cdf_entity: "Stock",
            cdf_action: "View",
            sort: sort !== undefined && sort !== null ? sort.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            source: source !== undefined && source !== null ? source.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see StockViewViewInvestSearchEvent
 */
export var StockViewViewInvestSearch = function (_a) {
    var origin = _a.origin;
    return ({
        name: "Stock View ViewInvestSearch",
        parameters: {
            cdf_entity: "Stock",
            cdf_action: "View",
            origin: origin !== undefined && origin !== null ? origin.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see StockViewViewAllNewsEvent
 */
export var StockViewViewAllNews = function (_a) {
    var source = _a.source, equityType = _a.equityType;
    return ({
        name: "Stock View ViewAllNews",
        parameters: {
            cdf_entity: "Stock",
            cdf_action: "View",
            source: source !== undefined && source !== null ? source.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            equity_type: equityType !== undefined && equityType !== null ? equityType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see StockViewViewKeyStatsDetailsEvent
 */
export var StockViewViewKeyStatsDetails = function (_a) {
    var ticker = _a.ticker, equityType = _a.equityType;
    return ({
        name: "Stock View ViewKeyStatsDetails",
        parameters: {
            cdf_entity: "Stock",
            cdf_action: "View",
            ticker: ticker !== undefined && ticker !== null ? ticker.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            equity_type: equityType !== undefined && equityType !== null ? equityType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see StockViewViewActivityDetailsEvent
 */
export var StockViewViewActivityDetails = function (_a) {
    var ticker = _a.ticker, equityType = _a.equityType;
    return ({
        name: "Stock View ViewActivityDetails",
        parameters: {
            cdf_entity: "Stock",
            cdf_action: "View",
            ticker: ticker !== undefined && ticker !== null ? ticker.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            equity_type: equityType !== undefined && equityType !== null ? equityType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see StockViewViewMyInvestmentDetailsEvent
 */
export var StockViewViewMyInvestmentDetails = function (_a) {
    var ticker = _a.ticker, equityType = _a.equityType;
    return ({
        name: "Stock View ViewMyInvestmentDetails",
        parameters: {
            cdf_entity: "Stock",
            cdf_action: "View",
            ticker: ticker !== undefined && ticker !== null ? ticker.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            equity_type: equityType !== undefined && equityType !== null ? equityType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see StockViewViewMoreHoldingsEvent
 */
export var StockViewViewMoreHoldings = function (_a) {
    var ticker = _a.ticker;
    return ({
        name: "Stock View ViewMoreHoldings",
        parameters: {
            cdf_entity: "Stock",
            cdf_action: "View",
            ticker: ticker !== undefined && ticker !== null ? ticker.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see StockOnboardCreateBrokerageAccountEvent
 */
export var StockOnboardCreateBrokerageAccount = function (_a) {
    var state = _a.state;
    return ({
        name: "Stock Onboard CreateBrokerageAccount",
        parameters: {
            cdf_entity: "Stock",
            cdf_action: "Onboard",
            state: state !== undefined && state !== null ? state.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see StockOffboardCloseBrokerageAccountEvent
 */
export var StockOffboardCloseBrokerageAccount = function () { return ({
    name: "Stock Offboard CloseBrokerageAccount",
    parameters: {
        cdf_entity: "Stock",
        cdf_action: "Offboard",
    }
}); };
/**
 * @see StockFollowFollowStockEvent
 */
export var StockFollowFollowStock = function (_a) {
    var status = _a.status, ticker = _a.ticker, equityType = _a.equityType;
    return ({
        name: "Stock Follow FollowStock",
        parameters: {
            cdf_entity: "Stock",
            cdf_action: "Follow",
            status: status !== undefined && status !== null ? status.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            ticker: ticker !== undefined && ticker !== null ? ticker.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            equity_type: equityType !== undefined && equityType !== null ? equityType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see StockOpenOpenCategoryEvent
 *
 * @deprecated Use `SelectCategory` instead.
 */
export var StockOpenOpenCategory = function (_a) {
    var categoryName = _a.categoryName;
    return ({
        name: "Stock Open OpenCategory",
        parameters: {
            cdf_entity: "Stock",
            cdf_action: "Open",
            category_name: categoryName !== undefined && categoryName !== null ? categoryName.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see StockOpenOpenCategoryStockEvent
 */
export var StockOpenOpenCategoryStock = function (_a) {
    var categoryName = _a.categoryName, ticker = _a.ticker;
    return ({
        name: "Stock Open OpenCategoryStock",
        parameters: {
            cdf_entity: "Stock",
            cdf_action: "Open",
            category_name: categoryName !== undefined && categoryName !== null ? categoryName.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            ticker: ticker !== undefined && ticker !== null ? ticker.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see StockOpenOpenSortByEvent
 */
export var StockOpenOpenSortBy = function () { return ({
    name: "Stock Open OpenSortBy",
    parameters: {
        cdf_entity: "Stock",
        cdf_action: "Open",
    }
}); };
/**
 * @see StockOpenOpenInvestSearchFilterEvent
 */
export var StockOpenOpenInvestSearchFilter = function (_a) {
    var filter = _a.filter;
    return ({
        name: "Stock Open OpenInvestSearchFilter",
        parameters: {
            cdf_entity: "Stock",
            cdf_action: "Open",
            filter: filter !== undefined && filter !== null ? filter.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see StockOpenOpenHoldingsDetailsStockEvent
 */
export var StockOpenOpenHoldingsDetailsStock = function (_a) {
    var ticker = _a.ticker;
    return ({
        name: "Stock Open OpenHoldingsDetailsStock",
        parameters: {
            cdf_entity: "Stock",
            cdf_action: "Open",
            ticker: ticker !== undefined && ticker !== null ? ticker.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see StockOpenOpenCategoryFilterEvent
 */
export var StockOpenOpenCategoryFilter = function (_a) {
    var categoryName = _a.categoryName;
    return ({
        name: "Stock Open OpenCategoryFilter",
        parameters: {
            cdf_entity: "Stock",
            cdf_action: "Open",
            category_name: categoryName !== undefined && categoryName !== null ? categoryName.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see StockScrollScrollNewsEvent
 */
export var StockScrollScrollNews = function (_a) {
    var source = _a.source;
    return ({
        name: "Stock Scroll ScrollNews",
        parameters: {
            cdf_entity: "Stock",
            cdf_action: "Scroll",
            source: source !== undefined && source !== null ? source.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see StockSelectSelectMyInvestmentsDetailsEvent
 */
export var StockSelectSelectMyInvestmentsDetails = function () { return ({
    name: "Stock Select SelectMyInvestmentsDetails",
    parameters: {
        cdf_entity: "Stock",
        cdf_action: "Select",
    }
}); };
/**
 * @see StockSelectPresentMyInvestmentsDetailsEvent
 */
export var StockSelectPresentMyInvestmentsDetails = function () { return ({
    name: "Stock Select PresentMyInvestmentsDetails",
    parameters: {
        cdf_entity: "Stock",
        cdf_action: "Select",
    }
}); };
/**
 * @see StockSelectSelectSortByEvent
 */
export var StockSelectSelectSortBy = function (_a) {
    var sort = _a.sort, source = _a.source;
    return ({
        name: "Stock Select SelectSortBy",
        parameters: {
            cdf_entity: "Stock",
            cdf_action: "Select",
            sort: sort !== undefined && sort !== null ? sort.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            source: source !== undefined && source !== null ? source.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see StockSelectSelectCategoryEvent
 */
export var StockSelectSelectCategory = function (_a) {
    var categoryName = _a.categoryName, origin = _a.origin, equityType = _a.equityType;
    return ({
        name: "Stock Select SelectCategory",
        parameters: {
            cdf_entity: "Stock",
            cdf_action: "Select",
            category_name: categoryName !== undefined && categoryName !== null ? categoryName.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            origin: origin !== undefined && origin !== null ? origin.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            equity_type: equityType !== undefined && equityType !== null ? equityType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see StockSelectSelectMyFirstStockEvent
 */
export var StockSelectSelectMyFirstStock = function () { return ({
    name: "Stock Select SelectMyFirstStock",
    parameters: {
        cdf_entity: "Stock",
        cdf_action: "Select",
    }
}); };
/**
 * @see StockSelectSelectDisclosuresEvent
 */
export var StockSelectSelectDisclosures = function (_a) {
    var origin = _a.origin;
    return ({
        name: "Stock Select SelectDisclosures",
        parameters: {
            cdf_entity: "Stock",
            cdf_action: "Select",
            origin: origin !== undefined && origin !== null ? origin.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see StockSelectSelectStockEvent
 */
export var StockSelectSelectStock = function (_a) {
    var origin = _a.origin;
    return ({
        name: "Stock Select SelectStock",
        parameters: {
            cdf_entity: "Stock",
            cdf_action: "Select",
            origin: origin !== undefined && origin !== null ? origin.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see StockSelectToggleStockSelectionEvent
 */
export var StockSelectToggleStockSelection = function (_a) {
    var isSelected = _a.isSelected, symbol = _a.symbol;
    return ({
        name: "Stock Select ToggleStockSelection",
        parameters: {
            cdf_entity: "Stock",
            cdf_action: "Select",
            is_selected: isSelected !== undefined && isSelected !== null ? isSelected.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            symbol: symbol !== undefined && symbol !== null ? symbol.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see StockSelectSubmitSelectionEvent
 */
export var StockSelectSubmitSelection = function (_a) {
    var flowToken = _a.flowToken, selectedSymbols = _a.selectedSymbols, ctaTitle = _a.ctaTitle;
    return ({
        name: "Stock Select SubmitSelection",
        parameters: {
            cdf_entity: "Stock",
            cdf_action: "Select",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            selected_symbols: selectedSymbols !== undefined && selectedSymbols !== null ? selectedSymbols.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            cta_title: ctaTitle !== undefined && ctaTitle !== null ? ctaTitle.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see StockSelectSubmitCancelEvent
 */
export var StockSelectSubmitCancel = function (_a) {
    var flowToken = _a.flowToken, intentToDisable = _a.intentToDisable, ctaTitle = _a.ctaTitle;
    return ({
        name: "Stock Select SubmitCancel",
        parameters: {
            cdf_entity: "Stock",
            cdf_action: "Select",
            flow_token: flowToken !== undefined && flowToken !== null ? flowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            intent_to_disable: intentToDisable !== undefined && intentToDisable !== null ? intentToDisable.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            cta_title: ctaTitle !== undefined && ctaTitle !== null ? ctaTitle.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see StockSelectSelectStockNotificationsEvent
 */
export var StockSelectSelectStockNotifications = function () { return ({
    name: "Stock Select SelectStockNotifications",
    parameters: {
        cdf_entity: "Stock",
        cdf_action: "Select",
    }
}); };
/**
 * @see StockSelectSelectSharePriceCustomEvent
 */
export var StockSelectSelectSharePriceCustom = function (_a) {
    var source = _a.source;
    return ({
        name: "Stock Select SelectSharePriceCustom",
        parameters: {
            cdf_entity: "Stock",
            cdf_action: "Select",
            source: source !== undefined && source !== null ? source.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see StockSelectSelectInvestSearchStockEvent
 */
export var StockSelectSelectInvestSearchStock = function (_a) {
    var ticker = _a.ticker, list = _a.list;
    return ({
        name: "Stock Select SelectInvestSearchStock",
        parameters: {
            cdf_entity: "Stock",
            cdf_action: "Select",
            ticker: ticker !== undefined && ticker !== null ? ticker.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            list: list !== undefined && list !== null ? list.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see StockSelectSelectInvestSearchFilterContinueEvent
 */
export var StockSelectSelectInvestSearchFilterContinue = function (_a) {
    var filter = _a.filter;
    return ({
        name: "Stock Select SelectInvestSearchFilterContinue",
        parameters: {
            cdf_entity: "Stock",
            cdf_action: "Select",
            filter: filter !== undefined && filter !== null ? filter.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see StockSelectSelectInvestSearchFilterOptionEvent
 */
export var StockSelectSelectInvestSearchFilterOption = function (_a) {
    var filter = _a.filter, categories = _a.categories, stockPerformance = _a.stockPerformance, timePeriod = _a.timePeriod, advanced = _a.advanced, options = _a.options;
    return ({
        name: "Stock Select SelectInvestSearchFilterOption",
        parameters: {
            cdf_entity: "Stock",
            cdf_action: "Select",
            filter: filter !== undefined && filter !== null ? filter.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            categories: categories !== undefined && categories !== null ? categories.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            stock_performance: stockPerformance !== undefined && stockPerformance !== null ? stockPerformance.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            time_period: timePeriod !== undefined && timePeriod !== null ? timePeriod.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            advanced: advanced !== undefined && advanced !== null ? advanced.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            options: options !== undefined && options !== null ? options.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see StockSelectSelectAutoInvestmentEvent
 */
export var StockSelectSelectAutoInvestment = function (_a) {
    var ticker = _a.ticker, equityType = _a.equityType;
    return ({
        name: "Stock Select SelectAutoInvestment",
        parameters: {
            cdf_entity: "Stock",
            cdf_action: "Select",
            ticker: ticker !== undefined && ticker !== null ? ticker.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            equity_type: equityType !== undefined && equityType !== null ? equityType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see StockSelectSelectHoldingsStockEvent
 */
export var StockSelectSelectHoldingsStock = function (_a) {
    var ticker = _a.ticker;
    return ({
        name: "Stock Select SelectHoldingsStock",
        parameters: {
            cdf_entity: "Stock",
            cdf_action: "Select",
            ticker: ticker !== undefined && ticker !== null ? ticker.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see StockSelectResetCategoryFilterEvent
 */
export var StockSelectResetCategoryFilter = function (_a) {
    var categoryName = _a.categoryName;
    return ({
        name: "Stock Select ResetCategoryFilter",
        parameters: {
            cdf_entity: "Stock",
            cdf_action: "Select",
            category_name: categoryName !== undefined && categoryName !== null ? categoryName.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see StockSelectApplyCategoryFilterEvent
 */
export var StockSelectApplyCategoryFilter = function (_a) {
    var categoryName = _a.categoryName, performance = _a.performance, advanced = _a.advanced, subcategories = _a.subcategories;
    return ({
        name: "Stock Select ApplyCategoryFilter",
        parameters: {
            cdf_entity: "Stock",
            cdf_action: "Select",
            category_name: categoryName !== undefined && categoryName !== null ? categoryName.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            performance: performance !== undefined && performance !== null ? performance.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            advanced: advanced !== undefined && advanced !== null ? advanced.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            subcategories: subcategories !== undefined && subcategories !== null ? subcategories.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see StockScrubScrubPriceStockDetailsEvent
 *
 * @deprecated This event is no longer needed, and it is not reported by clients.
 */
export var StockScrubScrubPriceStockDetails = function (_a) {
    var ticker = _a.ticker, equityType = _a.equityType;
    return ({
        name: "Stock Scrub ScrubPriceStockDetails",
        parameters: {
            cdf_entity: "Stock",
            cdf_action: "Scrub",
            ticker: ticker !== undefined && ticker !== null ? ticker.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            equity_type: equityType !== undefined && equityType !== null ? equityType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see StockScrubScrubPortfolioPerformanceEvent
 *
 * @deprecated This event is no longer needed, and it is not reported by clients.
 */
export var StockScrubScrubPortfolioPerformance = function () { return ({
    name: "Stock Scrub ScrubPortfolioPerformance",
    parameters: {
        cdf_entity: "Stock",
        cdf_action: "Scrub",
    }
}); };
/**
 * @see StockChangeChangeSharePriceEvent
 */
export var StockChangeChangeSharePrice = function (_a) {
    var source = _a.source, set = _a.set, percent = _a.percent;
    return ({
        name: "Stock Change ChangeSharePrice",
        parameters: {
            cdf_entity: "Stock",
            cdf_action: "Change",
            source: source !== undefined && source !== null ? source.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            set: set !== undefined && set !== null ? set.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            percent: percent !== undefined && percent !== null ? percent.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see StockChangeChangeSharePriceCustomEvent
 */
export var StockChangeChangeSharePriceCustom = function (_a) {
    var source = _a.source, percent = _a.percent;
    return ({
        name: "Stock Change ChangeSharePriceCustom",
        parameters: {
            cdf_entity: "Stock",
            cdf_action: "Change",
            source: source !== undefined && source !== null ? source.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            percent: percent !== undefined && percent !== null ? percent.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see StockChangeChangeEarningsEvent
 */
export var StockChangeChangeEarnings = function (_a) {
    var source = _a.source, set = _a.set;
    return ({
        name: "Stock Change ChangeEarnings",
        parameters: {
            cdf_entity: "Stock",
            cdf_action: "Change",
            source: source !== undefined && source !== null ? source.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            set: set !== undefined && set !== null ? set.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see StockInteractInteractInvestSearchEvent
 */
export var StockInteractInteractInvestSearch = function () { return ({
    name: "Stock Interact InteractInvestSearch",
    parameters: {
        cdf_entity: "Stock",
        cdf_action: "Interact",
    }
}); };
/**
 * @see StockSearchViewItemEvent
 */
export var StockSearchViewItem = function (_a) {
    var referrerFlowToken = _a.referrerFlowToken, searchFlowToken = _a.searchFlowToken, origin = _a.origin, businessToken = _a.businessToken, ticker = _a.ticker, searchTextLength = _a.searchTextLength, queryToken = _a.queryToken, absoluteIndex = _a.absoluteIndex, pathwayRank = _a.pathwayRank, searchOrigin = _a.searchOrigin;
    return ({
        name: "Stock Search ViewItem",
        parameters: {
            cdf_entity: "Stock",
            cdf_action: "Search",
            referrer_flow_token: referrerFlowToken !== undefined && referrerFlowToken !== null ? referrerFlowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            search_flow_token: searchFlowToken !== undefined && searchFlowToken !== null ? searchFlowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            origin: origin !== undefined && origin !== null ? origin.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            business_token: businessToken !== undefined && businessToken !== null ? businessToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            ticker: ticker !== undefined && ticker !== null ? ticker.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            search_text_length: searchTextLength !== undefined && searchTextLength !== null ? searchTextLength.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            query_token: queryToken !== undefined && queryToken !== null ? queryToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            absolute_index: absoluteIndex !== undefined && absoluteIndex !== null ? absoluteIndex.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            pathway_rank: pathwayRank !== undefined && pathwayRank !== null ? pathwayRank.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            search_origin: searchOrigin !== undefined && searchOrigin !== null ? searchOrigin.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see StockSearchSelectItemEvent
 */
export var StockSearchSelectItem = function (_a) {
    var referrerFlowToken = _a.referrerFlowToken, searchFlowToken = _a.searchFlowToken, origin = _a.origin, businessToken = _a.businessToken, ticker = _a.ticker, searchTextLength = _a.searchTextLength, queryToken = _a.queryToken, absoluteIndex = _a.absoluteIndex, pathwayRank = _a.pathwayRank, searchOrigin = _a.searchOrigin;
    return ({
        name: "Stock Search SelectItem",
        parameters: {
            cdf_entity: "Stock",
            cdf_action: "Search",
            referrer_flow_token: referrerFlowToken !== undefined && referrerFlowToken !== null ? referrerFlowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            search_flow_token: searchFlowToken !== undefined && searchFlowToken !== null ? searchFlowToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            origin: origin !== undefined && origin !== null ? origin.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            business_token: businessToken !== undefined && businessToken !== null ? businessToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            ticker: ticker !== undefined && ticker !== null ? ticker.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            search_text_length: searchTextLength !== undefined && searchTextLength !== null ? searchTextLength.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            query_token: queryToken !== undefined && queryToken !== null ? queryToken.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            absolute_index: absoluteIndex !== undefined && absoluteIndex !== null ? absoluteIndex.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            pathway_rank: pathwayRank !== undefined && pathwayRank !== null ? pathwayRank.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            search_origin: searchOrigin !== undefined && searchOrigin !== null ? searchOrigin.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see StockToggleToggleDividendReinvestmentsEvent
 */
export var StockToggleToggleDividendReinvestments = function (_a) {
    var source = _a.source, set = _a.set;
    return ({
        name: "Stock Toggle ToggleDividendReinvestments",
        parameters: {
            cdf_entity: "Stock",
            cdf_action: "Toggle",
            source: source !== undefined && source !== null ? source.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            set: set !== undefined && set !== null ? set.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see StockToggleStockToggleToggleGraphTimeRangeEvent
 */
export var StockToggleStockToggleToggleGraphTimeRange = function (_a) {
    var ticker = _a.ticker, timeRange = _a.timeRange, equityType = _a.equityType;
    return ({
        name: "Stock Toggle StockToggleToggleGraphTimeRange",
        parameters: {
            cdf_entity: "Stock",
            cdf_action: "Toggle",
            ticker: ticker !== undefined && ticker !== null ? ticker.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            timeRange: timeRange !== undefined && timeRange !== null ? timeRange.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            equity_type: equityType !== undefined && equityType !== null ? equityType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see StockToggleToggleFinancialWindowEvent
 */
export var StockToggleToggleFinancialWindow = function (_a) {
    var ticker = _a.ticker, financialWindowType = _a.financialWindowType;
    return ({
        name: "Stock Toggle ToggleFinancialWindow",
        parameters: {
            cdf_entity: "Stock",
            cdf_action: "Toggle",
            ticker: ticker !== undefined && ticker !== null ? ticker.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            financial_window_type: financialWindowType !== undefined && financialWindowType !== null ? financialWindowType.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see StockToggleToggleHoldingsDetailsGroupEvent
 */
export var StockToggleToggleHoldingsDetailsGroup = function (_a) {
    var ticker = _a.ticker, group = _a.group;
    return ({
        name: "Stock Toggle ToggleHoldingsDetailsGroup",
        parameters: {
            cdf_entity: "Stock",
            cdf_action: "Toggle",
            ticker: ticker !== undefined && ticker !== null ? ticker.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            group: group !== undefined && group !== null ? group.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
